"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldRenderInputGroup = exports["default"] = exports.FEEDBACK_TYPES = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.some");

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _warning = _interopRequireDefault(require("warning"));

var _reactTooltip = _interopRequireDefault(require("@nerdwallet/react-tooltip"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _reactTypography = _interopRequireDefault(require("@nerdwallet/react-typography"));

var _Error = _interopRequireDefault(require("@nerdwallet/react-icon/nerdwallet-ui/Error"));

var _FeedbackSuccess = _interopRequireDefault(require("@nerdwallet/react-icon/nerdwallet-ui/FeedbackSuccess"));

var _deprecate = require("@nerdwallet/deprecate");

var _bulletIcon = _interopRequireDefault(require("./bullet-icon"));

var _inputGroupModule = _interopRequireDefault(require("./input-group.module.css"));

var _FEEDBACK_COLOR_MAP, _FEEDBACK_ICON_MAP;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FEEDBACK_TYPES = {
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success'
};
exports.FEEDBACK_TYPES = FEEDBACK_TYPES;
var FEEDBACK_COLOR_MAP = (_FEEDBACK_COLOR_MAP = {}, _defineProperty(_FEEDBACK_COLOR_MAP, FEEDBACK_TYPES.ERROR, 'red-dark'), _defineProperty(_FEEDBACK_COLOR_MAP, FEEDBACK_TYPES.INFO, 'neutral-dark'), _defineProperty(_FEEDBACK_COLOR_MAP, FEEDBACK_TYPES.SUCCESS, 'green-dark'), _FEEDBACK_COLOR_MAP);
var FEEDBACK_ICON_MAP = (_FEEDBACK_ICON_MAP = {}, _defineProperty(_FEEDBACK_ICON_MAP, FEEDBACK_TYPES.ERROR, _Error["default"]), _defineProperty(_FEEDBACK_ICON_MAP, FEEDBACK_TYPES.INFO, _bulletIcon["default"]), _defineProperty(_FEEDBACK_ICON_MAP, FEEDBACK_TYPES.SUCCESS, _FeedbackSuccess["default"]), _FEEDBACK_ICON_MAP);
var fieldsetResetClassName = (0, _classnames["default"])([_inputGroupModule["default"]['min-width-0'], (0, _classes["default"])('border-all-0')]);
var legendResetClassName = (0, _classnames["default"])([(0, _classes["default"])('width-100')]);
/**
 * Determines if a component has any props that should trigger an InputGroup
 * to be rendered. Useful for components that want to conditionally wrap
 * themselves in an InputGroup if any InputGroup props are provided.
 *
 * @param {Object} props
 */

var shouldRenderInputGroup = function shouldRenderInputGroup(props) {
  return ['label', 'helpMessage', 'errorMessage', 'tooltip', 'feedback'].some(function (prop) {
    return props[prop] != null && (!(0, _isArray2["default"])(props[prop]) || props[prop].length);
  });
};
/**
 * Determines if the InputGroup is composing an Input,
 * or is being used as an InputGroup directly. Useful to set
 * display: inline-block on the outer <label> of an Input
 * component.
 */


exports.shouldRenderInputGroup = shouldRenderInputGroup;

var shouldDisplayInlineBlock = function shouldDisplayInlineBlock(children) {
  return _react["default"].Children.toArray(children).some(function (node) {
    return node && node.props && node.props.component === 'input' || node.type && node.type.name === 'Input';
  });
};
/**
 * Look for any children being used that have a component definition that set
 * the `shouldUseFieldset` hint. This tells InputGroup that it should render
 * using <fieldset> and <legend> instead of <label>. For example, this is set
 * by CheckboxGroup (@nerdwallet/react-checkbox).
 */


var childrenShouldUseFieldset = function childrenShouldUseFieldset(children) {
  return _react["default"].Children.toArray(children).some(function (node) {
    return node && node.type && node.type.shouldUseFieldset;
  });
};
/**
 * InputGroup renders the given input wrapped with proper spacing and support
 * for a label, help text, tooltip, and error state.
 */


var useInvalidPropsWarning = function useInvalidPropsWarning(_ref) {
  var error = _ref.error,
      errorMessage = _ref.errorMessage,
      help = _ref.help,
      tooltip = _ref.tooltip,
      inputId = _ref.inputId;
  (0, _react.useEffect)(function () {
    if (error) {
      (0, _warning["default"])(error && (errorMessage || help), "If using the error prop, provide an errorMessage to indicate what the error is.");
      (0, _warning["default"])(errorMessage && error, "If using the errorMessage prop, use the error prop as well to indicate an error exists.");
    }

    (0, _warning["default"])(!(tooltip && !inputId), "If using a tooltip with an input you also need to send an inputId");
  }, [error, errorMessage, help, tooltip, inputId]);
};

var InputGroup = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var className = props.className,
      disabled = props.disabled,
      error = props.error,
      errorMessage = props.errorMessage,
      errorMessageId = props.errorMessageId,
      feedbackMessages = props.feedbackMessages,
      fieldset = props.fieldset,
      help = props.help,
      helpMessage = props.helpMessage,
      helpMessageId = props.helpMessageId,
      input = props.input,
      inputId = props.inputId,
      fullWidth = props.fullWidth,
      label = props.label,
      tooltip = props.tooltip,
      tooltipPlacement = props.tooltipPlacement,
      otherProps = _objectWithoutProperties(props, ["className", "disabled", "error", "errorMessage", "errorMessageId", "feedbackMessages", "fieldset", "help", "helpMessage", "helpMessageId", "input", "inputId", "fullWidth", "label", "tooltip", "tooltipPlacement"]);

  (0, _deprecate.useDeprecatedPropsWarning)({
    component: 'InputGroup',
    deprecatedProps: [{
      version: '1.4.0',
      deprecated: 'help',
      migration: 'Use helpMessage instead.'
    }],
    props: props
  });
  useInvalidPropsWarning(props);
  /**
   * For convenience, an InputGroup will skip rendering any additional markup
   * if no relevant props are provided.
   */

  if (!shouldRenderInputGroup(props)) {
    return input;
  }

  var shouldUseFieldset = fieldset !== null ? fieldset : childrenShouldUseFieldset(input);
  var ContainerComponent = shouldUseFieldset ? 'fieldset' : 'label';
  var LabelComponent = shouldUseFieldset ? 'legend' : 'span';
  /**
   * Renders a red error message if either component has
   * 1) truthy error and errorMessage props or
   * 2) truthy error and help (deprecated) is provided
   *
   * Adds additional margin-top if a help message isn't set.
   */

  var renderErrorMessage = function renderErrorMessage() {
    if (!error) return null;
    var deprecatedError = error && help ? help : null;
    return (errorMessage || deprecatedError) && /*#__PURE__*/_react["default"].createElement(_reactTypography["default"] // This ensures that the message is not read as part of the input's
    // label when the input is being announced. This does not prevent
    // the screen reader from reading it when it's referenced via another
    // aria attribute, like `aria-describedby`.
    , {
      "aria-hidden": "true",
      className: (0, _classnames["default"])([(0, _classes["default"])('display-flex'), _defineProperty({}, (0, _classes["default"])('margin-top-1'), !helpMessage)]),
      error: true,
      size: 1,
      id: errorMessageId
    }, /*#__PURE__*/_react["default"].createElement(_Error["default"], {
      className: (0, _classes["default"])('margin-right-1', 'margin-top-1'),
      style: {
        flexShrink: 0
      }
    }), ' ', errorMessage || deprecatedError);
  };
  /**
   * Renders a gray help message if either
   * 1) helpMessage is provided
   * 2) help (deprecated) is provided if not used in conjunction with the error prop
   */


  var renderHelpMessage = function renderHelpMessage() {
    // The 'help' message in the deprecated path is actually the error message - don't render twice
    if (!(help || helpMessage) || help && error) return null;
    return /*#__PURE__*/_react["default"].createElement(_reactTypography["default"] // This ensures that the message is not read as part of the input's
    // label when the input is being announced. This does not prevent
    // the screen reader from reading it when it's referenced via another
    // aria attribute, like `aria-describedby`.
    , {
      "aria-hidden": "true",
      className: (0, _classes["default"])('margin-top-1'),
      color: "neutral-darkest",
      size: 1,
      id: helpMessageId
    }, helpMessage || help);
  };

  var renderFeedback = function renderFeedback() {
    if (!feedbackMessages || !(0, _isArray2["default"])(feedbackMessages)) return null;
    return feedbackMessages.map(function (f) {
      var IconComponent = FEEDBACK_ICON_MAP[f.feedbackType];
      return /*#__PURE__*/_react["default"].createElement(_reactTypography["default"] // This ensures that the message is not read as part of the input's
      // label when the input is being announced. This does not prevent
      // the screen reader from reading it when it's referenced via another
      // aria attribute, like `aria-describedby`.
      , {
        "aria-hidden": "true",
        className: (0, _classes["default"])('margin-top-1', 'display-flex'),
        color: FEEDBACK_COLOR_MAP[f.feedbackType],
        size: 1,
        id: f.id,
        key: f.message
      }, /*#__PURE__*/_react["default"].createElement(IconComponent, {
        className: (0, _classes["default"])('margin-right-1', 'margin-top-1'),
        style: {
          flexShrink: 0
        }
      }), f.message);
    });
  };

  return /*#__PURE__*/_react["default"].createElement(ContainerComponent, _extends({
    className: (0, _classnames["default"])([className, fullWidth ? (0, _classes["default"])('width-100') : null, ContainerComponent === 'fieldset' ? fieldsetResetClassName : null, // Since an element that is the labeled control of a
    // <label> and is matching :hover will trigger a hover style, we
    // want to set display: inline-block on the outer
    // <label> to minimize the mouse target area.
    shouldDisplayInlineBlock(input) ? (0, _classes["default"])('display-inline-block') : (0, _classes["default"])('display-block')]),
    ref: ref,
    htmlFor: inputId
  }, otherProps), (label || tooltip) && /*#__PURE__*/_react["default"].createElement(_reactTypography["default"], {
    component: LabelComponent,
    className: (0, _classnames["default"])([(0, _classes["default"])('margin-bottom-1', 'display-block'), disabled ? (0, _classes["default"])('opacity-50') : null, LabelComponent === 'legend' ? legendResetClassName : null]),
    size: 1
  }, tooltip ? /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
    label: label,
    title: "More information about ".concat(label),
    content: tooltip // use falsey comparison here, defaulting to top placement
    // to protect against null values
    ,
    placement: tooltipPlacement || InputGroup.defaultProps.tooltipPlacement
  }) : label), input, renderHelpMessage(), renderErrorMessage(), renderFeedback());
});

InputGroup.displayName = 'InputGroup';
InputGroup.defaultProps = {
  inputId: null,
  className: null,
  error: false,
  errorMessage: null,
  errorMessageId: null,
  feedbackMessages: null,
  fieldset: null,
  help: null,
  helpMessage: null,
  helpMessageId: null,
  label: null,
  tooltip: null,
  tooltipPlacement: 'top'
};
InputGroup.propTypes = {
  /** Id of input, required if you are using a tooltip */
  inputId: _propTypes["default"].string,

  /** Rendered input (e.g., `<Input />`) */
  input: _propTypes["default"].node.isRequired,

  /** A label for the input */
  label: _propTypes["default"].string,

  /**
   * Flag to indicate if input is in an error (red outline) state.
   * Use in conjunction with errorMessage to display a red error message.
   */
  error: _propTypes["default"].bool,

  /** Red text to be shown indicating the user is in an error state. */
  errorMessage: _propTypes["default"].node,

  /**
   * ID for the error message; this should be used with `aria-describedby` to
   * associate the error message with the input(s) nested inside this component.
   */
  errorMessageId: _propTypes["default"].string,

  /** A list of feedback messages to show for the group. */
  feedbackMessages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    feedbackType: _propTypes["default"].oneOf(Object.values(FEEDBACK_TYPES))
  })),

  /**
   * @deprecated
   * Please use helpMessage.
   */
  help: _propTypes["default"].node,

  /** Optional help text shown below the input */
  helpMessage: _propTypes["default"].node,

  /**
   * ID for the help message; this should be used with `aria-describedby` to
   * associate the help message with the input(s) nested inside this component.
   */
  helpMessageId: _propTypes["default"].string,

  /** Optional tooltip shown via an icon next to the label */
  tooltip: _propTypes["default"].node,

  /** Positioning of tooltip */
  tooltipPlacement: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * Uses <fieldset> and <legend> instead of <label>. Useful for radio buttons
   * and checkboxes. If this prop is not explicitly set, InputGroup will look
   * for the `shouldUseFieldset` hint on the given input.
   */
  fieldset: _propTypes["default"].bool,

  /** Class on outer container element */
  className: _propTypes["default"].string
};
var _default = InputGroup;
exports["default"] = _default;